import { render, staticRenderFns } from "./createCustomer.vue?vue&type=template&id=037e5e56&scoped=true"
import script from "./createCustomer.vue?vue&type=script&lang=js"
export * from "./createCustomer.vue?vue&type=script&lang=js"
import style0 from "./createCustomer.vue?vue&type=style&index=0&id=037e5e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e5e56",
  null
  
)

export default component.exports